export default "__VITE_PUBLIC_ASSET__25d883ed__"